import { Link } from 'react-router-dom';
import { allSections } from '@/utils/content';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 w-full bg-secondary-900 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-12 md:px-6 md:py-14">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-black">17吃瓜网</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            按娱乐区、社会区、科技圈、体育圈与网红圈做板块分区，点进对应分区就能看到该板块最近的八卦和话题更新，不用一个个翻。
          </p>
          <p className="mt-4 text-sm text-background-300">
            联系邮箱：<span className="text-background-100">hello@17chigua.example</span>
          </p>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-heading text-base font-bold text-background-50">板块分区</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {allSections.map((section) => (
              <li key={section.slug}>
                <Link
                  to={`/section/${section.slug}`}
                  className="cursor-pointer text-background-200 transition-colors hover:text-primary-300"
                >
                  {section.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-heading text-base font-bold text-background-50">网站</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/" className="cursor-pointer text-background-200 transition-colors hover:text-primary-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer text-background-200 transition-colors hover:text-primary-300">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about#contact" className="cursor-pointer text-background-200 transition-colors hover:text-primary-300">
                联系方式
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="font-heading text-base font-bold text-background-50">内容提示</h3>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            站内内容为话题整理与观察记录，仅供日常浏览参考，不构成任何事实认定。
          </p>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <span>© {year} 17吃瓜网 · 一个轻松的吃瓜话题站点</span>
          <span>内容每日整理更新</span>
        </div>
      </div>
    </footer>
  );
}